import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-topic-wise-score',
  templateUrl: './topic-wise-score.component.html',
  styleUrls: ['./topic-wise-score.component.scss']
})
export class TopicWiseScoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
